import { apiCallWithAuthToken } from "./config";
import { Token } from "./pools";

export interface Chain {
  createdAt: string;
  updatedAt: string;
  id: number;
  name: string;
  chainId: string;
  chainSelectorCCIP: string;
  routerAddress: string;
  isSupported: boolean;
  contracts: {
    id: string;
    name: string;
    address: string;
    version: string;
    lastKnownBlock: string;
    createdAt: string;
    updatedAt: string;
  }[];
  tokens: {
    id: string;
    token: Token;
    address: string;
    name: string;
    symbol: string;
    decimals: number;
    createdAt: string;
    updatedAt: string;
  }[];
}

type SupportedChainsResponse = Chain[];

export const getSupportedChains = async () =>
  apiCallWithAuthToken.get<SupportedChainsResponse>("/chains");
